import React from "react";
import { Icon } from "@iconify/react";
import style from "../../../scss/Tabla.module.scss";
import { ESTADOS_COMPROMISO, contarCompromisos } from "../../../constants/compromiso";

const TARJETAS = [
  { estado: ESTADOS_COMPROMISO.CUMPLIDO, total: "cumplidos", etiqueta: "Cumplidos", color: "text-success" },
  { estado: ESTADOS_COMPROMISO.PENDIENTE, total: "pendientes", etiqueta: "Por cumplir", color: "text-secondary" },
];

// Totales de compromisos cumplidos y por cumplir; al hacer clic en una tarjeta
// la tabla muestra solo esos electores (otro clic quita el filtro)
const ResumenCompromisoComponent = ({ electores, filtroActivo, onFiltrar }) => {
  const totales = contarCompromisos(electores);

  return (
    <div className={style.resumenCompromisos} role="group" aria-label="Filtrar por estado del compromiso">
      {TARJETAS.map(({ estado, total, etiqueta, color }) => {
        const activa = filtroActivo === estado.valor;
        return (
          <button
            key={estado.valor}
            type="button"
            className={`${style.tarjetaCompromiso} ${color} ${activa ? style.tarjetaActiva : ""}`}
            onClick={() => onFiltrar(activa ? null : estado.valor)}
            aria-pressed={activa}
            title={activa ? "Mostrar todos" : `Mostrar solo: ${etiqueta.toLowerCase()}`}
          >
            <Icon icon={estado.icono} className={style.tarjetaIcono} aria-hidden="true" />
            <span className={style.tarjetaDatos}>
              <strong>{totales[total].toLocaleString()}</strong>
              <span>{etiqueta}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default ResumenCompromisoComponent;
